import { FeatureAppLoader } from '@feature-hub/react';
import {
  Breakpoints,
  Container,
  ContainerGutter,
  ContainerPadding,
  IntegratorRoot,
  Layout,
  ThemeProvider,
} from '@vw-marketing/us-components';
import { History } from 'history';
import React from 'react';

import {
  FaContentServiceV1,
  Content,
} from '@volkswagen-onehub/fa-content-service';

import { appsUMD, appsCommonsJS } from './app-constants';
import Ngw6AppRender from './components/ngw6-app-render';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import {
  contentFeatureAppMap,
  getConfigsFeatureApp,
} from './feature-app-helpers';
import {
  BrowserRouter,
  Routes,
  Route,
  unstable_HistoryRouter as HistoryRouter, //TODO: check if HistoryRouter is needed
} from 'react-router-dom';


export interface IntegratorProps extends ModelOverviewIntegratorOptions {
  readonly history: History;
}

export function Integrator({
  baseUrl,
  history,
  ssr,
  featureAppName = 'default',
  ...props
}: IntegratorProps): JSX.Element {
  const featureAppConfig = getConfigsFeatureApp({
    ...props,
    featureAppName,
  });

  return (
    <IntegratorRoot>
      <ThemeProvider variant="v26">
        <Layout
          appearance={{
            [Breakpoints.default]: [
              { name: '.', columns: 0 },
              { name: 'a', columns: 24 },
              { name: '.', columns: 0 },
            ],
            [Breakpoints.b960]: [
              { name: '.', columns: 2 },
              { name: 'a', columns: 20 },
              { name: '.', columns: 2 },
            ],
          }}
          allowOverflowingContent
        >
          <Container
            wrap="always"
            padding={{
              top: ContainerPadding.static0,
              bottom: ContainerPadding.static350,
            }}
            gutter={ContainerGutter.static500}
          >
            <BrowserRouter>
              <Routes>
                <Route
                  path="/"
                  element={
                    <FeatureAppLoader
                      featureAppId="battery-label"
                      baseUrl={baseUrl}
                      src={appsUMD[featureAppName]}
                      serverSrc={
                        ssr ? appsCommonsJS[featureAppName] : undefined
                      }
                      config={featureAppConfig}
                      beforeCreate={({ featureServices }) => {
                        const content: Content =
                          contentFeatureAppMap[featureAppName];

                        if (content) {
                          (
                            featureServices[
                              'fa-content-service'
                            ] as FaContentServiceV1
                          ).content = content;
                        }
                      }}
                    />
                  }
                />
                <Route
                  path="/application-render/:appId"
                  element={
                    <Ngw6AppRender isSsr={ssr} baseUrl={baseUrl} {...props} />
                  }
                />
              </Routes>
            </BrowserRouter>
          </Container>
        </Layout>
      </ThemeProvider>
    </IntegratorRoot>
  );
}
